import {ReactComponent as TimeIcon} from './time.svg'

function Time() {
  return <TimeIcon />
}

export default Time
